import { PatientInformationFormState } from "./type";
import { ApplicationState } from "..";
import { isNullOrUndefined } from "util";

export const getRegionCodeArray = (state: PatientInformationFormState) => {
    const regionCodeArray: string[] = [];
    for (const addr of state.patientInformation.addresses.filter(p => !isNullOrUndefined(p.zipCode))) {
        regionCodeArray.push(addr.zipCode.replace(/\s|\(|\)|_|-|\+/g, ''));
    }
    return regionCodeArray;
}

export const getCurrentPatientIdForSaga = (state: ApplicationState) => state.patientInformationForm.patientInformation.patientId;

export const getCurrentPatientInformation = (state: PatientInformationFormState) => state.patientInformation;

export const getCurrentPatientInformationForSaga = (state: ApplicationState) => state.patientInformationForm.patientInformation;

export const getCurrentPatientInformationMode = (state: PatientInformationFormState) => state.patientInterfaceForm.currentPatientInfoMode;

export const getShowPatientInformationEditModal = (state: PatientInformationFormState) => state.patientInterfaceForm.patientInfoEditPopupVisible;

export const getCurrentEditPopupSelected = (state: PatientInformationFormState) => state.patientInterfaceForm.patientInfoEditSelectedCategory;

export const getCurrentEditPopupCategoryIndex = (state: PatientInformationFormState) => state.patientInterfaceForm.patientInfoEditIndex;

export const getIsCurrentItemNew = (state: PatientInformationFormState) => state.patientInterfaceForm.patientInfoEditIsNewItem;

export const getIsDatePickerVisibile = (state: PatientInformationFormState) => state.patientInterfaceForm.showDateSelector;

export const getPopupDeleteConfirmationVisibility = (state: PatientInformationFormState) => state.patientInterfaceForm.patientInfoEditDeletePopupVisible;



// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/selectors.ts